import React from 'react';
import type { FragmentProps } from './fragment.types';

const Fragment: React.FC<FragmentProps> = ({ showIf = true, children }) => {
    if (!showIf) return null;
    return <>{children}</>;
};

export default Fragment;
